import { Typography } from '@fox/atoms';
import styled from 'styled-components';

export const CAROUSEL_ITEM_WIDTH = 500 as const;
export const CAROUSEL_ITEM_GAP = 32 as const;
export type DynamicCarouselCardType = 'news' | 'events';

export type DynamicCarouselCard = {
	id: number;
	position: number;
	props: any;
	type: DynamicCarouselCardType;
};
export const DynamicCarouselWrapper = styled.div`
	position: relative;
	gap: 1rem;
	overflow: hidden;
	width: 100%;
	height: 168px;
	@media (max-width: 800px) {
		display: flex;
		flex-direction: column;
		column-gap: 1rem;
		align-items: center;
		overflow: auto;
		height: max-content;
	}
`;

export const DynamicCardLeftFadeOverlay = styled.div<{ $visible: boolean; $fadeOutGradientColour?: string }>`
	position: absolute;
	top: 0px;
	width: ${CAROUSEL_ITEM_WIDTH};
	left: 0px;
	height: 168px;
	width: 150px;
	background-image: linear-gradient(to right, ${props => props.$fadeOutGradientColour ?? 'rgba(255, 254, 254, 1)'}, rgba(255, 0, 0, 0));
	opacity: ${props => (props.$visible ? 1 : 0)};
	${props => (props.$visible ? 'transition: opacity 0.25s ease-in;' : '')}
	@media (max-width: 800px) {
		display: none;
	}
`;
export const DynamicCardRightFadeOverlay = styled.div<{ $visible: boolean; $fadeOutGradientColour?: string }>`
	position: absolute;
	top: 0px;
	right: 0px;
	width: ${CAROUSEL_ITEM_WIDTH};
	height: 168px;
	width: 150px;
	background-image: linear-gradient(to left, ${props => props.$fadeOutGradientColour ?? 'rgba(255, 254, 254, 1)'}, rgba(255, 0, 0, 0));
	opacity: ${props => (props.$visible ? 1 : 0)};
	${props => (props.$visible ? 'transition: opacity 0.25s ease-in;' : '')}
	@media (max-width: 800px) {
		display: none;
	}
`;

export const DynamicListCarouselButtonWrapper = styled.div<{ $visible: boolean; $backgroundColour?: string }>`
	background-color: ${props => props.$backgroundColour ?? 'rgb(243, 244, 242)'};
	padding: 0.5rem;
	border-radius: 30px;
	display: flex;
	align-items: center;
	cursor: pointer;
	opacity: ${props => (props.$visible ? 1 : 0)};
	pointer-events: ${props => (props.$visible ? 'all' : 'none')};
	transition: opacity 0.25s ease-in-out;
	@media (max-width: 800px) {
		display: none;
	}
`;

export const DynamicCardLink = styled.a`
	text-decoration: none;
	color: inherit;
	display: block;
	width: 100%;
`;

export const DynamicCardImage = styled.img`
	border-radius: 16px;
	min-width: 150px;
	width: 150px;
	height: 150px;
	object-fit: cover;
	@media (max-width: 800px) {
		width: 100%;
		height: 300px;
		border-radius: 16px 16px 0px 0px;
	}
	@media (max-width: 600px) {
		height: 168px;
	}
`;

export const DynamicCardMain = styled.div`
	padding: 0.5rem 0.5rem 0rem 0rem;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	height: 150px;
	overflow: hidden;
	@media (max-width: 800px) {
		padding: 0.5rem;
	}
`;

export const DynamicCard = styled.div`
	display: flex;
	gap: 1rem;
	width: 500px;
	padding: 8px;
	@media (max-width: 800px) {
		flex-direction: column;
		max-width: 100%;
	}
	@media (max-width: 600px) {
		width: 100%;
	}
`;

export const Description = styled(Typography)`
	-webkit-line-clamp: 2;
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
`;
export const Title = styled(Typography)<{ $numberOfLines?: number }>`
	-webkit-line-clamp: ${props => props.$numberOfLines ?? 2};
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	line-height: 1.75rem;
	font-size: 1.5rem;
`;
export const DateText = styled(Typography)`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	font-size: 0.8rem;
`;

export const DynamicCardWrapper = styled.div<{
	$position: number;
}>`
	position: absolute;
	margin-left: ${props => props.$position * (CAROUSEL_ITEM_WIDTH + CAROUSEL_ITEM_GAP)}px;
	border-radius: 16px;
	border: 1px solid ${props => props.theme.palette.grey[300]};
	transition: margin-left 0.25s ease-in-out;
	background-color: ${props => props.theme.colors.white};

	@media (max-width: 800px) {
		position: initial;
		margin-left: 0px;
	}

	@media (max-width: 600px) {
		width: 100%;
	}
`;
